import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Seu CSS do Tailwind
import App from './App';
import { AppProvider } from './context/AppContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </React.StrictMode>
);